import Box from '@mui/material/Box'
import { styled } from '@mui/material/styles'
import MUITooltip, { tooltipClasses, TooltipProps } from '@mui/material/Tooltip'
import React, { FC } from 'react'

import { LuneTheme } from '../theme'

type ITooltip = TooltipProps & {
    contentWidth?: boolean
}

const Tooltip: FC<ITooltip & { style?: React.CSSProperties }> = (props) => {
    const { contentWidth, style, children, ...tooltipProps } = props
    const { palette, typography } = LuneTheme

    const StyledTooltip = styled(({ className, ...tooltipProps }: TooltipProps) => (
        <MUITooltip {...tooltipProps} arrow classes={{ popper: className }} />
    ))(() => ({
        [`& .${tooltipClasses.arrow}`]: {
            color: palette.Grey900,
        },
        [`& .${tooltipClasses.tooltip}`]: {
            ...typography.caption,
            backgroundColor: palette.Grey900,
            padding: '8px',
            borderRadius: '4px',
        },
    }))

    return (
        <StyledTooltip {...tooltipProps} data-testid="tooltip">
            <Box
                component={'span'}
                sx={{
                    display: 'block',
                    maxWidth: contentWidth ? 'max-content' : 'none',
                    ...(style || {}),
                }}
            >
                {children}
            </Box>
        </StyledTooltip>
    )
}

export const TooltipList: FC<{ items: React.ReactNode[] | string[] }> = ({ items }) => {
    return (
        <ul
            style={{
                listStyleType: 'disc',
                marginLeft: '12px',
                paddingLeft: '0',
                fontSize: 'small',
            }}
        >
            {items.map((item, i) => (
                <li
                    style={{
                        marginLeft: '8px',
                        lineHeight: '16px',
                    }}
                    key={i}
                >
                    {item}
                </li>
            ))}
        </ul>
    )
}

export default Tooltip
